<template>
  <div :class="{ opDialog:true, opDialogActive: visible,blueBackground:isBlueBackground }">
    <div
      v-if="title"
      class="opDialog_head"
    >
      <div class="opDialog_title">
        {{ title }}
      </div>
      <div
        class="opDialog_close"
        @click="handlerClose"
      >
        x
      </div>
    </div>
    <div
      v-else
      class="opDialog_close_absolute"
      @click="handlerClose"
    >
      x
    </div>
    <div class="opDialog_body">
      <slot />
    </div>
    <div
      v-if="isShowBtn"
      class="opDialog_btns"
    >
      <!-- <div
        class="opDialog_btns_btn"
        @click="handlerClose"
      >
        {{ cancelText }}
      </div> -->
      <!-- <div
        class="opDialog_btns_btn opDialog_btns_btn-ok"
        :loading="okLoading"
        @click="handlerOk"
      >
        {{ okText }}
      </div> -->
      <OppleButton
        v-if="isShowCancelBtn"
        type="default"
        :disabled="okLoading"
        @click="handlerClose"
      >
        {{ cancelText }}
      </OppleButton>
      <OppleButton
        :disabled="okDisabled"
        :loading="okLoading"
        @click="handlerOk"
      >
        {{ okText }}
      </OppleButton>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n/i18n'
import OppleButton from '@/components/Base/OppleButton/index.vue'

export default {
  components: {
    OppleButton
  },
  props: {
    title: {
      type: String,
      default: ''
      // default: i18n.t('ifttt.notice')
    },
    visible:  {
      type: Boolean,
      default: false
    },
    isShowBtn: {
      type: Boolean,
      default: true
    },
    isBlueBackground: {
      type: Boolean,
      default: false
    },
    cancelText: {
      type: String,
      default: () => i18n.t('limite.cancel')
    },
    okText: {
      type: String,
      default: () => i18n.t('limite.ok')
    },
    okLoading: {
      type: Boolean,
      default: false
    },
    isShowCancelBtn: {
      type: Boolean,
      default: true
    },
    okDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  watch: {
    visible(isVisable) {
    }
  },
  methods: {
    handlerOk() {
      const slot = this.getSlot();
      const data = slot.getData instanceof Function ? slot.getData() : null;

      this.$emit('onOk', data);

      slot.clearData instanceof Function && slot.clearData();
    },
    handlerClose() {
      const slot = this.getSlot();

      slot.clearData instanceof Function && slot.clearData();

      this.$emit('onClose');
    },

    getSlot() {
      if (
        this.$slots.default &&
        this.$slots.default[0] &&
        this.$slots.default[0].componentInstance
      ) {
        return this.$slots.default[0].componentInstance;
      }

      return {};
    },
    
  }
}
</script>

<style lang="scss">
.opDialog {
  display: none;
  position: fixed;
  width: 1273px;
  min-height: 600px;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.302);
  z-index: 1099;

  &.opDialogActive {
    display: block;
  }

  &_head {
    display: flex;
    padding: 10px 13px;
    margin-bottom: 20px;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    background: #2145A4;
    border-radius: 12px 12px 0 0;
  }

  &_close {
    cursor: pointer;

    &_absolute {
      position: absolute;
      font-size: 24px;
      right: 40px;
      top: 20px;
      cursor: pointer;
      transform: scaleY(0.8);
      z-index: 999;
    }
  }

  &_body {
    min-height: 570px;
    max-height: 670px;
    overflow: scroll;
    //background: #E7ECF7;
  }

  &_btns {
    display: flex;
    justify-content: flex-end;
    margin-right: 32px;
    padding-top: 6px;
    padding-bottom: 16px;

    &>div {
      margin-left: 16px;
    }
  }
}
.blueBackground{
  background: #E7ECF6;
}
</style>
